import { useEffect } from "react";
import { useDebugMode } from "components/DebugContext/DebugContext";
import * as amplitude from '@amplitude/analytics-browser';


const AmplitudeProvider = () => {
  const { debugMode } = useDebugMode();


  useEffect(() => {
    const init = async () => {
      try {
        const amplitudeApiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;
        const amplitudeServerZone = process.env.REACT_APP_AMPLITUDE_SERVER_ZONE as "EU" | "US";
        if (amplitudeApiKey && amplitudeServerZone) {
          amplitude.init(amplitudeApiKey, { "autocapture": false, fetchRemoteConfig: true, serverZone: amplitudeServerZone });

          if (debugMode) console.log("Amplitude initialized");
        } else {
          if (debugMode) console.error("Amplitude API key not found");
        }
      } catch (error) {
        if (debugMode) console.error("Error initializing Amplitude:", error);
      }
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default AmplitudeProvider;